import { isFeatureEnabled } from 'common/utils';

/**
 * Same-origin path fronting the Datadog browser intake. Served by the CloudFront `/ddintake/*`
 * behavior (infrastructure-cdk2), which forwards to the telemetry-relay so telemetry is delivered
 * past enterprise egress filters that block `browser-intake-datadoghq.com`.
 */
const DDINTAKE_PATH = '/ddintake';

type DatadogProxyFn = (options: { path: string; parameters: string }) => string;

/**
 * The Datadog browser-SDK `proxy` option, gated by the `DatadogProxyEnabled` feature flag.
 *
 * When enabled, RUM / Session Replay / logs intake is routed same-origin through
 * `<origin>/ddintake/...` instead of directly to Datadog. When disabled, returns `undefined` so the
 * SDK posts straight to Datadog exactly as before (the flag defaults off per environment).
 */
export const getDatadogProxy = (): DatadogProxyFn | undefined =>
  isFeatureEnabled('DatadogProxyEnabled')
    ? ({ path, parameters }) => `${window.location.origin}${DDINTAKE_PATH}${path}?${parameters}`
    : undefined;
